import { TextField } from '@app/styles/forms';
import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Input = styled(TextField)`
  flex: 1;
  padding-right: 40px;
  border-color: #e9ecef;
`;

export const SearchLabel = styled.span`
  margin-top: 5px;
  font-size: 12px;
  color: #999999;
`;

export const ClearButton = styled(IconButton)`
  position: absolute !important;
  top: 0px;
  right: 0px;
`;
